var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_3",
    "data-name": "Component 27 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3006",
    "data-name": "Rectangle 3006",
    width: 27,
    height: 27,
    rx: 5,
    fill: "#fdb713",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-eye",
    "data-name": "Icon ionic-ios-eye",
    transform: "translate(1.748 0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11953",
    "data-name": "Path 11953",
    d: "M11.413,7.875c-3.292,0-5.887,2.072-8.99,5.457a.647.647,0,0,0,0,.872c2.657,2.935,5,5.461,8.994,5.461,3.947,0,6.906-3.181,9.011-5.486a.642.642,0,0,0,.02-.847C18.3,10.733,15.331,7.875,11.413,7.875Zm.18,9.576A3.684,3.684,0,1,1,15.1,13.942,3.686,3.686,0,0,1,11.593,17.451Z",
    fill: "#1492e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11954",
    "data-name": "Path 11954",
    d: "M16.121,14.2a1.924,1.924,0,0,1,.127-.692c-.041,0-.082,0-.127,0a2.62,2.62,0,1,0,2.62,2.62c0-.053,0-.106,0-.16a1.815,1.815,0,0,1-.745.16A1.9,1.9,0,0,1,16.121,14.2Z",
    transform: "translate(-4.7 -2.35)",
    fill: "#1492e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.990685c0ea3a684ee5750836699dbdc1.svg";
export { ForwardRef as ReactComponent };